module.exports = __webpack_public_path__ + "img/Welding servicies on the piping prefabrication facility.f676e8bb.png";